import { ApiBlank, type BlankProductData, BlankSideEnum, BlankSingleSideEnum } from "../../interfaces/blank";
import type { CustomizationImageElement, CustomizationTextElement } from "../../interfaces/customization";
import { ApiBlankFaceEnum } from "./formatDataToApi/getBlankFace";

export const formatBlankSingleSideFromApi = (
  face: ApiBlankFaceEnum.FRONT | ApiBlankFaceEnum.BACK,
): BlankSingleSideEnum => (face === ApiBlankFaceEnum.BACK ? BlankSingleSideEnum.BACK : BlankSingleSideEnum.FRONT);

export const formatBlankSideFromApi = (face: ApiBlankFaceEnum) => {
  switch (face) {
    case ApiBlankFaceEnum.BACK:
      return BlankSideEnum.BACK;
    case ApiBlankFaceEnum.FRONT:
      return BlankSideEnum.FRONT;
    default:
      return BlankSideEnum.FRONT_BACK;
  }
};

export const formatBlanksDataFromApi = (data: ApiBlank[]): BlankProductData[] =>
  data.map(({ title, public: gender, price, technicalSheet, images, ...blank }) => ({
    ...blank,
    name: title,
    gender,
    price: +price,
    tecnicalDetails: technicalSheet,
    imageSrc: images.find(({ mainImage }) => mainImage)?.imageUrl || "",
    imageSrc2: images.find(({ mainImage }) => mainImage)?.imageUrl2 || null,
    images: images.map(({ showFace, customizationPrice, imageUrl, imageUrl2, ...image }) => {
      const blankArea = blank.area ? blank.area[showFace] : { w: 0, h: 0 };

      return {
        ...image,
        showSide: formatBlankSideFromApi(showFace),
        customizationPrice: +customizationPrice,
        imageSrc: imageUrl,
        imageSrc2: imageUrl2,
        printSize: blankArea,
      };
    }),
  }));

export const formatCustomizationTextElementDataFromApi = (
  element: CustomizationTextElement & { size: { w: number; h: number } },
  canvasSize: { w: number; h: number },
) => {
  const { position, rotation, fontSize, size } = element;
  const rotationDegrees = (rotation / 180) * Math.PI;

  return {
    ...element,
    position: {
      x:
        (position.x + 0.5) * canvasSize.w -
        size.w * canvasSize.w * Math.cos(rotationDegrees) * 0.5 +
        size.h * canvasSize.h * Math.sin(rotationDegrees) * 0.5,
      y:
        (position.y + 0.5) * canvasSize.h -
        size.w * canvasSize.w * Math.sin(rotationDegrees) * 0.5 -
        size.h * canvasSize.h * Math.cos(rotationDegrees) * 0.5,
    },
    fontSize: fontSize * canvasSize.h,
  };
};

export const formatCustomizationImageElementDataFromApi = (
  element: CustomizationImageElement & { size: { w: number; h: number } },
  canvasSize: { w: number; h: number },
  imageEl: HTMLImageElement,
  degradedImageEl: HTMLImageElement,
) => {
  const { position, size } = element;

  return {
    ...element,
    element: imageEl,
    degradedElement: degradedImageEl,
    position: {
      x: (position.x + 0.5) * canvasSize.w,
      y: (position.y + 0.5) * canvasSize.h,
    },
    scale: {
      x: (size.w * canvasSize.w) / imageEl.naturalWidth,
      y: (size.h * canvasSize.h) / imageEl.naturalHeight,
    },
  };
};
